import { createAction } from "../action";
import { APP } from "./constants";

export const appActions = {
  start: () => createAction(APP.START),
};
